//Swiper
let mySwiper = document.querySelectorAll(".mobile-swiper");

mySwiper.forEach(function (item) {
  var swiper = new Swiper(item, {
    preloadImages: false,
    lazy: true,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
});

//ATC Appear
let mobileATCAppear = function () {
  if (window.pageYOffset > 58) {
    document.querySelectorAll(".mobile-atc")[0].classList.add("show");
  } else {
    document.querySelectorAll(".mobile-atc")[0].classList.remove("show");
  }
};

mobileATCAppear();

window.addEventListener("scroll", function () {
  mobileATCAppear();
});

//Remove Empty Colors
let singleColor = document.querySelectorAll(".single-color");

singleColor.forEach(function (item) {
  if (item.dataset.handle == "") {
    item.style.display = "none";
  }
});

//Dropdowns
let dropWrap = document.querySelectorAll(".atc-options");

let sizeParent = document.querySelectorAll(".select-size");
let colorParent = document.querySelectorAll(".select-color");

let sizeDropBtn = document.querySelectorAll(".size-drop-btn");
let colorDropBtn = document.querySelectorAll(".color-drop-btn");

let sizeDropDown = document.querySelectorAll(".size-dropdown");
let colorDropDown = document.querySelectorAll(".colors-dropdown");

let multiColorCheck = document.querySelectorAll(".colors-dropdown")[0];

if (multiColorCheck) {
  multiColorCheck = multiColorCheck.dataset.limit;
}

sizeDropBtn.forEach(function (item) {
  item.addEventListener("click", function (event) {
    event.preventDefault();
    item.classList.toggle("open");

    colorParent.forEach(function (item) {
      item.classList.remove("expand");
    });

    sizeParent.forEach(function (item) {
      item.classList.add("expand");
    });

    dropWrap.forEach(function (item) {
      item.classList.toggle("highlight");
    });

    colorDropDown.forEach(function (jtem) {
      jtem.classList.remove("open");
    });

    sizeDropDown.forEach(function (jtem) {
      jtem.classList.toggle("open");
    });
  });
});


colorDropBtn.forEach(function (item) {
  if (multiColorCheck == "single") {
    item.classList.add("single");
  }

  item.addEventListener("click", function (event) {
    event.preventDefault();
    item.classList.toggle("open");

    sizeParent.forEach(function (item) {
      item.classList.remove("expand");
    });

    colorParent.forEach(function (item) {
      item.classList.add("expand");
    });

    dropWrap.forEach(function (item) {
      item.classList.toggle("highlight");
    });

    sizeDropDown.forEach(function (jtem) {
      jtem.classList.remove("open");
    });

    colorDropDown.forEach(function (jtem) {
      jtem.classList.toggle("open");
    });
  });
});

//Move Details and Size to Accordion Section
let acDetails = document.querySelector(".description .ac-details");
let acSize = document.querySelector(".description .ac-size");

let detailsBlock = document.querySelectorAll(".acc-block-details");
let sizeBlock = document.querySelectorAll(".acc-block-size");

//console.log(detailsBlock.length + " " + sizeBlock.length);

if (detailsBlock.length > 0) {
  if (acDetails) {
    detailsBlock.forEach(function (item) {
      item.appendChild(acDetails.cloneNode(true));
    });
  }
}

if (sizeBlock.length > 0) {
  if (acSize) {
    sizeBlock.forEach(function (item) {
      item.appendChild(acSize.cloneNode(true));
    });
  }
}

//Accordions
let accBlocks = document.querySelectorAll(".acc-con");

accBlocks.forEach(function (item, i) {
  let btn = item.querySelector(".acc-btn");

  let closeBlock = function (i) {
    accBlocks.forEach(function (item, j) {
      if (i != j) {
        item.classList.remove("active");
      }
    });
  };

  btn.addEventListener("click", function (event) {
    event.preventDefault();

    // If "Shop the Look" is clicked
    if (btn.id === "shop-the-look") {
      const targetSection = document.querySelector(".you-may-also-like");
      if (targetSection) {
        const yOffset = -147; // offset for fixed header
        const y = targetSection.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
      return; // Exit without toggling
    }

    closeBlock(i);
    item.classList.toggle("active");
  });
});


//Size Guide Button and Tables
let sizeGuideBtn = document.querySelectorAll(".size-guide-btn");
let sizeGuideTable = document.querySelector("#size-guide-wrap");

if(sizeGuideBtn.length > 0){
  sizeGuideBtn.forEach(function(item){
    item.addEventListener("click", function(event){
      event.preventDefault();
      sizeGuideTable.classList.add("active");
    });
  });
}

//Add To Cart - Button
let atcBtn = document.querySelectorAll(".product-btn");
let atcForm = document.querySelector('#atc-form');

atcBtn.forEach(function (item) {
  item.addEventListener("click", function (event) {
    let form = document.querySelector("#atc-form");
    let theFunction = item.dataset.function;
    if (item.classList.contains("disabled")) {
      event.preventDefault();
      let selectSize = document.querySelectorAll(".select-size");
      selectSize.forEach(function (item) {
        item.classList.add("expand");
        item.querySelector(".size-drop-btn").classList.add("open");
        item.querySelector(".size-dropdown").classList.add("open");
      });

      //console.log('disabled button');
    } else {
      event.preventDefault();
      //console.log("add to cart button");
      if (theFunction == "atc") {
        event.preventDefault();
        if(item.dataset.preOrder){
          coATC(item.dataset.variantId, item.dataset.preOrder, form);
          console.log(item.dataset.preOrder);
        } else {
          coATC(item.dataset.variantId, item.dataset.returnPolicy, form);
          console.log(item.dataset.preOrder);
        }
      } else if (theFunction == "inquire") {
      } else if (theFunction == "sold-out") {
        event.preventDefault();
      } else {
        event.preventDefault();
        console.log(item.dataset.size);
        document.querySelector("#notify-size").innerText = item.dataset.size;
        document.querySelector("#product-notify").classList.add("active");
      }
    }
  });
});

//Add To Cart - Options
let sizeOptions = document.querySelectorAll(".size-options");
//console.log(sizeOptions.length);

sizeOptions.forEach(function (ktem, k) {
  let links = ktem.querySelectorAll("a");
  links.forEach(function (item) {
    item.addEventListener("click", function (event) {
      event.preventDefault();
      let qty = item.dataset.quantity;
      let size = item.dataset.name;
      let variantId = item.dataset.value;
      let preOrder = item.dataset.preOrder;

      colorParent.forEach(function (item) {
        item.classList.remove("expand");
      });

      sizeParent.forEach(function (item) {
        item.classList.remove("expand");
      });

      dropWrap.forEach(function (item) {
        item.classList.remove("highlight");
      });

      sizeDropBtn.forEach(function (jtem) {
        jtem.innerText = size;
      });

      sizeDropDown.forEach(function (jtem) {
        jtem.classList.remove("open");
      });

      if (qty > 0) {
        atcBtn.forEach(function (jtem) {
          jtem.dataset.variantId = variantId;
          jtem.dataset.size = size;
          jtem.dataset.function = "atc";
          jtem.innerText = "Add To Bag";
          jtem.classList.remove("disabled");
        });
        atcForm.querySelector('input[name="id"]').value = variantId;
      } else {
        if(preOrder == "continue"){
          atcBtn.forEach(function (jtem) {
            jtem.dataset.variantId = variantId;
            jtem.dataset.size = size;
            jtem.dataset.function = "atc";
            //jtem.innerText = "Pre-Order";
            //jtem.innerText = "Pre-Order";
            jtem.innerText = "Add To Bag";
            jtem.classList.remove("disabled");
          });
          atcForm.querySelector('input[name="id"]').value = variantId;
        } else {
          let setNotifyBtn = document.querySelector("#send-notify-info");
          atcBtn.forEach(function (jtem) {
            setNotifyBtn.dataset.variantId = variantId;
            jtem.dataset.variantId = variantId;
            jtem.dataset.size = size;
            jtem.dataset.function = "notify";
            jtem.innerText = "Notify Me When Available";
            jtem.classList.remove("disabled");
          });
        }
      }
    });
  });
});

//Add To Cart - Cart Value
let coATC = function(theID, returnPolicy, form){
  var formdata = false;
  if (form) {
    form.querySelector('input[name="id"]').value = parseInt(theID);
    if (window.FormData) {
      formdata = new FormData(form);
    }
  }

  let intID = parseInt(theID);

  data = {
    id: intID,
    quantity: 1,
    // properties: {
    //   'Return Policy': returnPolicy
    // }
  };

  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: formdata ? formdata : data,
    contentType: false,
    processData: false,
    dataType: "json",
    success: function () {
      document.querySelector("#side-cart").classList.add("active");
      displayCart();
    },
  });
}

//Klaviyo Product Notification
const submitNotifyBtn = document.querySelector("#send-notify-info");

if (submitNotifyBtn) {
  submitNotifyBtn.addEventListener("click", function (event) {
    event.preventDefault();
    const notifyEmail = document.querySelector("#notify-user-email").value;
    const variantId = submitNotifyBtn.dataset.variantId;

    if (!notifyEmail || !variantId) {
      document.querySelector("#product-notify .error").classList.remove("hide");
      return;
    }

    const klaviyoVariantId = "$shopify:::$default:::" + variantId;

    const payload = {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: notifyEmail
              }
            }
          },
          channels: ["EMAIL"],
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: klaviyoVariantId
            }
          }
        }
      }
    };

    var requestOptions = {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "revision":"2024-06-15"
        },
        body: JSON.stringify(payload),
    };

    fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=YB3duh`, requestOptions)
      .then(res => {
        if (res.ok) {
          // Check if there is content to parse
          return res.text().then((text) => (text ? JSON.parse(text) : {}));
        } else {
          return res.json().then((errorDetails) => {
            throw new Error(`Failed to subscribe: ${errorDetails.message}`);
          });
        }
      })
      .then(res => {
        console.log("Subscription successful:", res);
        document.querySelector("#product-notify .error").classList.add("hide");
        document.querySelector("#product-notify .before").classList.add("hide");
        document.querySelector("#product-notify .after").classList.remove("hide");
      })
      .catch(err => {
        console.error("Back in Stock error:", err.message);
        document.querySelector("#product-notify .error").classList.add("hide");
      });
  });
}

//Image Zoom
let gallery = document.querySelector(".product-pg");
let galleryLinks = gallery.querySelectorAll(".gallery .img-zoom");

galleryLinks.forEach(function (item, i) {
  item.addEventListener("click", function (event) {
    event.preventDefault();
    gallery.classList.toggle("zoom");
    item.scrollIntoView();
    //let image = item.querySelector("img").src;
  });
});

//Single Variant
let singleVariant = document.querySelector("#no-variant");

if (singleVariant) {
  atcBtn.forEach(function (item) {
    item.classList.remove("disabled");
    item.dataset.variantId = singleVariant.dataset.singleVariant;
  });
}


//Member button
let memberBtn = document.querySelector(".upsell a");
if (memberBtn) {
  memberBtn.addEventListener("click", function (event) {
    document.querySelector(".upsell a .circle").classList.add("checked");
  });
}


//Extra
let extraBtn = document.querySelectorAll('.extra-btn');
let extraCon = document.querySelectorAll('.extra .collection-con');
if(extraBtn){
  extraBtn.forEach(function(item, i){
    item.addEventListener('click', function(event){
      event.preventDefault();
      if (i == 0) {
        extraBtn[1].classList.remove("active");
        extraCon[1].classList.remove("active");
        extraBtn[0].classList.add('active');
        extraCon[0].classList.add("active");
      } else {
        extraBtn[0].classList.remove("active");
        extraCon[0].classList.remove("active");
        extraBtn[1].classList.add("active");
        extraCon[1].classList.add("active");
      }
    });
  });
}

//Set Mobile ATC
var swiper = new Swiper('.ultra-wide', {
  //preloadImages: false,
  //loop: true,
  slidesPerView: 1.5,
  spaceBetween: 2,
  freeMode: true,
  breakpoints: {
    650: {
      slidesPerView: 2.5,
    },
    1280: {
      slidesPerView: 3.5,
    }
  },
});


//Mobile ATC
//Single Atc Button
let setSingleAtcBtn = function (singleProduct) {
  let singleAtcBtns = singleProduct.querySelectorAll(".single-atc-btn");

  singleAtcBtns.forEach((item) => {
    let idData = item.dataset.id;
    if (!idData) return;

    let singleID = parseInt(idData, 10);

    item.addEventListener("click", function (event) {
      event.preventDefault();

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: singleID,
          quantity: 1,
        })
      })
      .then(response => response.json())
      .then(data => {
        document.querySelector("#side-cart").classList.add("active");
        displayCart(); // make sure this function exists globally
      })
      .catch(error => console.error('Error adding item to cart:', error));
    });
  });
}

let allProducts = document.querySelectorAll("#collection-con .product");

allProducts.forEach((singleProduct) => {
  let plpAtc = singleProduct.querySelector(".plp-add-to-cart");

  if (plpAtc) {
    let togglePLPAtc = plpAtc.querySelector(".toggle-atc-btn");

    if (togglePLPAtc) {
      togglePLPAtc.addEventListener("click", function (event) {
        event.preventDefault();
        plpAtc.classList.add("active");
      });
    }
  }

  //setSingleAtcBtn(singleProduct);
});

function removeDeliveryPromise() {
  const elements = document.querySelectorAll('delivery-promise-wc[slot="promise"][data-strategy="add-to-cart-form"]');

  elements.forEach(el => {
    el.remove();
  });
}

// Initial run
removeDeliveryPromise();

// Keep checking every 500ms in case elements are added dynamically
const observer = new MutationObserver(removeDeliveryPromise);
observer.observe(document.body, { childList: true, subtree: true });

//Variant URL Selector
document.addEventListener('DOMContentLoaded', function () {
  const url = window.location.href;

  document.querySelectorAll('#size-dropdown a[data-value]').forEach((option) => {
    const dataValue = option.getAttribute('data-value');
    if (url.includes(dataValue)) {
      option.click();
    }
  });
});
